import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useUser, useAuthStatus, pathWithMfaGate} from "../../allauth/auth";
import SplashScreen from "./SplashScreen";

export default function Landing() {

    const location = useLocation();
    const me = useUser();
    const navigate = useNavigate();
    const [auth] = useAuthStatus();
    const permissions = useSelector(state => state.permissions);

    useEffect(() => {
        if (location.pathname === '/') {
            if (me) {
                if (!permissions.loading) {
                    const target = pathWithMfaGate(permissions, auth, '/select-campaign');
                    navigate(target);
                }
            } else {
                navigate('/login');
            }
        }
    }, [me, location, permissions, auth])

    return <SplashScreen />
}
